import { render, staticRenderFns } from "./Fenix.vue?vue&type=template&id=5b27f550&scoped=true&"
import script from "./Fenix.vue?vue&type=script&lang=js&"
export * from "./Fenix.vue?vue&type=script&lang=js&"
import style0 from "./Fenix.vue?vue&type=style&index=0&id=5b27f550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b27f550",
  null
  
)

export default component.exports